const type = 'SET_ORG';

const setOrg = (data) => ({
  type,
  data,
});

export { type };
export default setOrg;
